import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  PreferenceOptionContainer,
  Checkbox,
  Image,
  Modal,
  ImageLabel,
  Link,
  ModalContent,
  ImageContainer,
  ModalImage,
} from '../styles';

const PreferenceOption = (props) => {
  const {
    option,
    selected,
    onSelect,
    readOnly,
  } = props;

  const {
    imageUrl,
    id,
    label,
  } = option;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = (event) => {
    event.stopPropagation();
    setIsModalOpen(false);
  };

  const handleClickImage = () => {
    if (readOnly) {
      setIsModalOpen(true);
    } else {
      onSelect();
    }
  };

  return (
    <PreferenceOptionContainer>
      <Checkbox
        radio
        key={id}
        label={label}
        onChange={onSelect}
        checked={selected}
        disabled={readOnly}
        readOnly={readOnly}
      />
      <Image
        onClick={handleClickImage}
        src={imageUrl}
        size="small"
        readOnly={readOnly}
      />
      <ImageLabel readOnly={readOnly}>
        <Link onClick={() => setIsModalOpen(true)}>
          Click to enlarge image
        </Link>
      </ImageLabel>
      {
        isModalOpen && (
          <Modal
            open={isModalOpen}
            onClose={handleCloseModal}
            closeIcon
            onClick={(ev) => ev.stopPropagation()}
          >
            <ModalContent>
              <ImageContainer>
                <ModalImage
                  src={imageUrl}
                />
              </ImageContainer>
              <Link onClick={handleCloseModal}>
                Exit Image Preview
              </Link>
            </ModalContent>
          </Modal>
        )
      }
    </PreferenceOptionContainer>
  );
};

// create proptypes
PreferenceOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    imageUrl: PropTypes.string,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
  readOnly: PropTypes.bool,
};

PreferenceOption.defaultProps = {
  onSelect: () => {},
  readOnly: false,
};

export default PreferenceOption;
